module.exports = __webpack_public_path__ + "static/media/logo.d09f6d0b.png";